export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) {
    return "0 B"
  }
  const k = 1024
  const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB"]
  const i = Math.min(
    units.length - 1,
    Math.floor(Math.log(bytes) / Math.log(k)),
  )
  const value = bytes / k ** i
  return `${value % 1 === 0 ? value : value.toFixed(1)} ${units[i]}`
}
